/**
 * ITHR co-brand strip. Renders the OFFICIAL ITHR mono-white SVG on a dark
 * navy band. Used at the bottom of every page so every surface carries the
 * parent-company attribution.
 *
 * The logo file lives in /public/ithr-mono-white.svg — embedded as-is, never
 * recolored or recreated.
 */
export default function CoBrandStrip({ className = "" }) {
  return (
    <div
      className={`bg-hero-dark border-t border-white/10 ${className}`}
      data-testid="cobrand-strip"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-5 flex flex-wrap items-center justify-center gap-3">
        <img
          src="/ithr-mono-white.svg"
          alt="ITHR Technologies Consulting LLC"
          className="h-6 w-auto select-none"
          style={{ height: "24px" }}
          data-testid="cobrand-logo"
          draggable={false}
        />
        <span className="text-[12px] tracking-[0.04em] text-[var(--text-on-dark-muted)]">
          A product by{" "}
          <span className="font-semibold text-white">
            ITHR Technologies Consulting LLC
          </span>
        </span>
      </div>
    </div>
  );
}
